import React from 'react';
import { AppBar, Toolbar, useScrollTrigger, Grid } from '@mui/material';

const Nav = (props) => {
  function ElevationScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
      disableHysteresis: true,
      threshold: 0,
      target: window ? window() : undefined,
    });
    return React.cloneElement(children, {
      elevation: trigger ? 4 : 0,
    });
  }

  return (
    <ElevationScroll {...props}>
      <AppBar style={{ maxHeight: '60px' }}>
        <Toolbar style={{ height: '40px', backgroundColor: 'rgba(240,240,240, 1)', color: 'grey' }}>
          <Grid container spacing={0}>
            <Grid size={{ xs: 12 }}>
              <ul className='navContainer'>
                <li className='navItem homeButton'>
                  <a style={{ padding: '0px' }} href='https://www.cts-companies.com'>
                    <img className='homeImage' src='https://www.cts-companies.com/wp-content/uploads/2021/03/CTS_Logo_2_Transparent.png' alt='CTS Companies Logo'/>
                  </a>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </ElevationScroll>
  );
};

export default Nav;
